/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CreateFragmentSocialUploadsMutationRequest, CreateFragmentSocialUploadsMutationResponse } from "../models/CreateFragmentSocialUploads";

export function getCreateFragmentSocialUploadsUrl() {
  const res = { method: 'POST', url: `/fragment-social-uploads` as const }
  return res
}

/**
 * @summary Start upload of fragment or video-editor project media to platform
 * {@link /fragment-social-uploads}
 */
export async function createFragmentSocialUploads(data: CreateFragmentSocialUploadsMutationRequest, config: Partial<RequestConfig<CreateFragmentSocialUploadsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateFragmentSocialUploadsMutationResponse, ResponseErrorConfig<Error>, CreateFragmentSocialUploadsMutationRequest>({ method : "POST", url : getCreateFragmentSocialUploadsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}